export enum Locale {
  EN = 'en',
  IT = 'it',
}
